import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { BgImage } from "gbimage-bridge";
import styled from "styled-components";
import CountUp, { useCountUp } from "react-countup";

const Background = styled(BgImage)`
  ::after {
    background-position: top !important;
  }
  ::before {
    background-position: top !important;
  }
`;

const StyledContainer = styled.div`
  width: 100%;
  background: white;
  padding: 10px;
  display: grid;
  grid-template-rows: 1fr auto;


  @media (min-width: 641px) {
    /* font-size: ; */
  }
`;

const CountdownStatement = styled.h2`
  display: block;
  color: #1f3b36;
  line-height: 1.227em;
  padding: 20px;
  font-size: 1em;
  margin: 0;
  padding-top: 50%;

  @media (min-width: 391px) {
    font-size: 1.2em;
  }
  @media (min-width: 461px) {
    font-size: 1.4em;
  }
  @media (min-width: 541px) {
    font-size: 1.6em;
  }
  @media (min-width: 641px) {
    font-size: 0.8em;
    /* font-size: 1em; */
  }
`;

const CountdownUnit = styled.h2`
  color: #1f3b35;
  margin: 0.5em 0;
  font-size: 1em;
`;

const Countdown = ({
  images,
  target = 100,
  suffix = " units",
  imageName = "countdown_01",
  text = "",
}) => {
  const [isIntersecting, setIntersecting] = useState(false);
  const elRef = useRef();

  const observer = new IntersectionObserver(([entry]) =>
    setIntersecting(entry.isIntersecting)
  );
  useEffect(() => {
    observer.observe(elRef.current);
    // Remove the observer as soon as the component is unmounted
    return () => {
      observer.disconnect();
    };
  }, []);

  const { countUp, start, reset } = useCountUp({
    duration: 0.8,
    end: target,
    separator: ",",
  });

  useEffect(() => {
    if (isIntersecting) {
      start();
    } else {
      reset();
    }
  }, [isIntersecting]);

  return (
    <StyledContainer>
      <Background image={images[imageName].gatsbyImageData}>
        <div>
          <CountdownStatement>{text}</CountdownStatement>
        </div>
      </Background>
      <CountdownUnit ref={elRef}>
        {countUp} {suffix}
      </CountdownUnit>
    </StyledContainer>
  );
};

export default Countdown;
